import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

export const DateRangeBarChart = ({
  data,
  xKey,
  barKey,
  isSessionCount,
  isPeakHoursCount,
}: any) => {
  const transformedData = data.map((item: any) => ({
    ...item,
  }));

  console.log(transformedData, "trnasformedData");

  const colors = [
    "#fdb508",
    "#327171",
    "#8884d8",
    "#f48a0f",
    "#ffca33",
    "#4d8c8c",
    "#9e9bef",
    "#ff9e33",
    "#e6a500",
    "#245656",
    "#6b68b0",
    "#e67400",
    "#ffdd66",
    "#66a3a3",
    "#b0acf5",
    "#ffb066",
  ];

  const getColor = (hour: number) => colors[hour % colors.length];

  const formatHourLabel = (h: number) => {
    const suffix = h >= 12 ? "PM" : "AM";
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    return `${hour12} ${suffix}`;
  };

  return (
    <BarChart
      width={1200}
      height={500}
      data={transformedData}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis
        dataKey={xKey}
        angle={-35}
        interval={0}
        tick={{ fontSize: 10, fontWeight: "bold" }}
        height={85}
        dy={25}
        dx={-25}
      />
      <YAxis />
      <Tooltip />
      {isSessionCount && <Legend />}
      {!(isSessionCount || isPeakHoursCount) && (
        <Bar dataKey={barKey} stackId="a" fill="#a0a7e6" />
      )}
      {isSessionCount && <Bar dataKey="single" stackId="a" fill="#8884d8" />}
      {isSessionCount && (
        <Bar dataKey="used_subscription" stackId="a" fill="#a0a7e6" />
      )}
      {isPeakHoursCount &&
        Array.from({ length: 24 }, (_: any, h: any) => (
          <Bar
            key={h}
            dataKey={`${h} Hours`}
            stackId="a"
            fill={getColor(h)}
            name={formatHourLabel(h)}
          />
        ))}
    </BarChart>
  );
};
